<template>
  <modal name="share_customer_spotlight_modal" @before-open="beforeOpen" height="auto">
    <div
      class="modal_container modal_container--customer_spotlight"
      v-if="customer_spotlight || caseStudy"
      :class="{ freestanding: freestanding }"
    >
      <div class="modal_header mb-0">
        <h2>Download Customer Spotlight</h2>
        <div
          class="closer"
          @click="$modal.hide('share_customer_spotlight_modal')"
          v-if="!freestanding"
        >
          <TimesIcon />
        </div>
      </div>

      <div class="modal_body">
        <section class="share-option">
          <b-form-group>
            <b-form-radio v-model="filetype" name="filetype-radios" value="pdf">
              Single-page PDF
            </b-form-radio>
          </b-form-group>
        </section>

        <div class="download mt-1">
          <b-button variant="primary" block disabled v-if="download_in_progress">
            Generating&hellip;
          </b-button>
          <b-button variant="primary" block @click="onDownload" v-if="!download_in_progress">
            Download
          </b-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
import TimesIcon from './graphics/TimesIcon.vue'
import api from '../app/mixins/api.js'
import { AxiosResponse } from 'axios'
import { trackEvent, assetEventData } from '@lib/tracking'

export default {
  components: { TimesIcon },
  mixins: [api],
  props: ['freestanding'],
  data() {
    return {
      filetype: 'pdf',
      download_in_progress: false,
      customer_spotlight: null,
      caseStudy: null,
    }
  },
  computed: {
    download_options() {
      return {
        filetype: this.filetype,
      }
    },
    eventData() {
      if (this.customer_spotlight) {
        return {
          ...assetEventData(this.customer_spotlight),
          filetype: this.filetype,
        }
      }
      return {
        ...assetEventData(this.caseStudy),
        filetype: this.filetype,
      }
    },
  },
  methods: {
    beforeOpen(e) {
      if (e.params.customer_spotlight) {
        this.customer_spotlight = e.params.customer_spotlight
      } else {
        this.caseStudy = e.params.case_study
      }
    },
    attemptPopUp(url: string) {
      const new_window = window.open(url, '_blank')
      try {
        new_window.focus()
      } catch (e) {
        // Trying to `window.open` a PDF attachment file seems to trigger pop-up blockers on Chrome
        alert(
          'It looks like a pop-up blocker prevented the download window from opening. Please allow them for this site.',
        )
      }
    },
    onDownload() {
      trackEvent('asset downloaded', this.eventData)

      this.download_in_progress = true

      if (this.customer_spotlight) {
        this.renderCustomerSpotlight(this.customer_spotlight.id, this.download_options)
          .then((r: AxiosResponse) => {
            return r.data.download_url
          })
          .then((url: string) => this.attemptPopUp(url))
          .catch(() => alert('Darn! Something went wrong. Please try again.'))
          .finally(() => (this.download_in_progress = false))
      } else if (this.caseStudy) {
        this.renderCaseStudy(this.caseStudy.id, this.download_options)
          .then((r: AxiosResponse) => {
            return r.data.download_url
          })
          .then((url: string) => this.attemptPopUp(url))
          .catch(() => alert('Darn! Something went wrong. Please try again.'))
          .finally(() => (this.download_in_progress = false))
      }
    },
  },
}
</script>
